<h2 mat-dialog-title class="dialog-header">
  <div class="dialog-title-block">
    <div class="dialog-title-row">
      <div>
        <div class="dialog-title">{{ line.payment?.uuid }}</div>
        <div *ngIf="line.orderUuid" class="dialog-meta">Order UUID: {{ line.orderUuid }}</div>
        <div class="dialog-subtitle">Detalle de cobro, carrito, ticket e invoice asociado.</div>
      </div>
      <span class="status-pill" [ngClass]="line.payment?.status?.toLowerCase()">{{ line.payment?.status|traduccion }}</span>
    </div>
  </div>

  <button mat-icon-button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content">
  <div class="info-grid" appGridColumns [colsLg]="2" [colsMd]="2" [colsSm]="1" [colWidths]="[50, 50]">
    <mat-card class="detail-card accent-card">
      <div class="card-heading">
        <h3>{{'payment.details.payment'|traduccion}}</h3>
        <mat-icon>payments</mat-icon>
      </div>

      <div class="detail-list">
        <div class="detail-item">
          <span class="detail-label">{{'payment.details.createdAt'|traduccion}}</span>
          <strong>{{ line.payment?.createdAt | date: appService.FORMAT_DATETIME }}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'payment.details.status'|traduccion}}</span>
          <strong>{{line.payment?.status|traduccion}}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'payment.details.type'|traduccion}}</span>
          <strong>{{ 'payment.details.type.'+line.payment?.type|traduccion}}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'payment.details.panCard'|traduccion}}</span>
          <strong>{{ line.payment?.panCard }} {{diff?.panCard ? '('+diff?.panCard.kiosk+')' : ''}}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'payment.details.basePrice'|traduccion}}</span>
          <strong>{{ line.payment?.basePrice|currency }} {{diff?.basePrice ? '('+diff?.basePrice.kiosk+')' : ''}}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'payment.details.tax'|traduccion}}</span>
          <strong>{{ line.payment?.taxPrice|currency }} {{diff?.taxPrice ? '('+diff?.taxPrice.kiosk+')' : ''}} ({{ line.payment?.tax * 100 }} {{diff?.tax ? '('+diff?.tax.kiosk+')' : ''}}%)</strong>
        </div>
        <div class="detail-item total-item">
          <span class="detail-label">{{'payment.details.totalPrice'|traduccion}}</span>
          <strong>{{ line.payment?.totalPrice|currency }} {{diff?.totalPrice ? '('+diff?.totalPrice.kiosk+')' : ''}}</strong>
        </div>
      </div>

      <div *ngIf="line.payment?.mode!='REFUND'" class="action-row">
        <button *ngIf="line.payment?.status=='CHECKOUT'" mat-stroked-button color="warn" (click)="cancelOrRefundPayment()">
          <mat-icon>cancel</mat-icon>
          {{'payment.action.cancel'|traduccion}}
        </button>
        <button *ngIf="line.payment?.status=='CAPTURE'" mat-stroked-button color="warn" (click)="cancelOrRefundPayment()">
          <mat-icon>money_off</mat-icon>
          {{'payment.action.refund'|traduccion}}
        </button>
        <button *ngIf="line.payment?.status=='CHECKOUT'" mat-stroked-button color="warn" (click)="capturePayment()">
          <mat-icon>capture</mat-icon>
          {{'payment.action.capture'|traduccion}}
        </button>
      </div>
    </mat-card>

    <mat-card class="detail-card">
      <div class="card-heading">
        <h3>{{'payment.details.cart'|traduccion}}</h3>
        <mat-icon>shopping_bag</mat-icon>
      </div>

      <div class="detail-list">
        <div class="detail-item">
          <span class="detail-label">{{'payment.details.cart.startDate'|traduccion}}</span>
          <strong>{{ line.order.cart?.startDate | date: appService.FORMAT_DATETIME }}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'payment.details.cart.endDate'|traduccion}}</span>
          <strong>{{ line.order.cart?.endDate | date: appService.FORMAT_DATETIME }}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'payment.details.cart.name'|traduccion}}</span>
          <strong>{{line.order.cart.userData.name}}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'payment.details.cart.email'|traduccion}}</span>
          <strong>{{line.order.cart.userData.email}}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'payment.details.cart.telephoneNumber'|traduccion}}</span>
          <strong>{{line.order.cart.userData.extension}}{{line.order.cart.userData.telephoneNumber}}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'payment.details.cart.langCode'|traduccion}}</span>
          <img class="flag" src="assets/webp/{{line.order.cart.userData.langCode}}.webp" alt="{{line.order.cart.userData.langCode}}"/>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'payment.details.cart.discountCode'|traduccion}}</span>
          <strong>{{line.order.cart.userData.discountCode || '-'}}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'payment.details.cart.insurance'|traduccion}}</span>
          <strong>{{'str.'+line.order.cart.userData.insurance|traduccion}}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'payment.details.cart.agreement'|traduccion}}</span>
          <strong>{{'str.'+line.order.cart.userData.agreement|traduccion}}</strong>
        </div>
      </div>

      <div class="list-block">
        <span class="detail-label">{{'items'|traduccion}}</span>
        <ul>
          <li *ngFor="let item of line.order.cart?.items">{{getCategoryCode(item?.categoryId) |traduccion}}</li>
        </ul>
      </div>
    </mat-card>
  </div>

  <div class="info-grid" appGridColumns [colsLg]="2" [colsMd]="2" [colsSm]="1" [colWidths]="[50, 50]">
    <mat-card class="detail-card">
      <div class="card-heading">
        <h3>{{'payment.details.ticket'|traduccion}} {{ line.payment?.dataTicket?.ticketNumber }}</h3>
        <mat-icon>receipt_long</mat-icon>
      </div>

      <div class="detail-list">
        <div class="detail-item">
          <span class="detail-label">{{'payment.details.ticket.date'|traduccion}}</span>
          <strong>{{ line.payment?.dataTicket?.date }}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'payment.details.ticket.type'|traduccion}}</span>
          <strong>{{ line.payment?.dataTicket?.type }}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'payment.details.ticket.langCode'|traduccion}}</span>
          <img class="flag" src="assets/webp/{{line.order.cart.userData.langCode}}.webp" alt="{{line.order.cart.userData.langCode}}"/>
        </div>
        <div class="detail-item total-item">
          <span class="detail-label">{{'payment.details.ticket.total'|traduccion}}</span>
          <strong>{{line.payment?.dataTicket?.totalPriceWithTax|currency}}</strong>
        </div>
      </div>

      <div class="list-block">
        <span class="detail-label">{{'payment.details.ticket.products'|traduccion}}</span>
        <ul>
          <li *ngFor="let product of line.payment?.dataTicket.products">{{product.name}}</li>
        </ul>
      </div>

      <div class="action-row">
        <button mat-stroked-button (click)="downloadTicket()"><mat-icon>download</mat-icon>{{'payment.details.ticket.download'|traduccion}}</button>
        <button mat-stroked-button *appShowForRoles="['ROLE_ADMIN', 'ROLE_MANAGER']" (click)="regenerateQrTicket()"><mat-icon>qr_code_2_add</mat-icon>{{'payment.details.ticket.regenerate'|traduccion}}</button>
        <button mat-stroked-button *appShowForRoles="['ROLE_ADMIN']" (click)="generateTicket()"><mat-icon>confirmation_number</mat-icon>{{'payment.details.ticket.generate'|traduccion}}</button>
        <button mat-stroked-button *appShowForRoles="['ROLE_ADMIN', 'ROLE_MANAGER']" (click)="printTicket()"><mat-icon>print</mat-icon>{{'payment.details.ticket.print'|traduccion}}</button>
        <button mat-button *appShowForRoles="['ROLE_ADMIN']" (click)="openDialogTicketRawData()">{{'payment.details.ticket.rawData'|traduccion}}</button>
      </div>
    </mat-card>

    <mat-card *ngIf="line.payment?.invoice" class="detail-card">
      <div class="card-heading">
        <h3>{{'invoice'|traduccion}} {{ line.payment?.invoice?.invoiceNumber }}</h3>
        <mat-icon>description</mat-icon>
      </div>

      <div class="detail-list">
        <div class="detail-item">
          <span class="detail-label">{{'invoice.createdAt'|traduccion}}</span>
          <strong>{{ line.payment?.invoice?.createdAt | date: appService.FORMAT_DATETIME }}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'invoice.status'|traduccion}}</span>
          <strong>{{ line.payment?.invoice?.status }}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'invoice.addressClient'|traduccion}}</span>
          <strong>{{ line.payment?.invoice?.addressClient }}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'invoice.companyNameClient'|traduccion}}</span>
          <strong>{{ line.payment?.invoice?.companyNameClient }}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'invoice.emailClient'|traduccion}}</span>
          <strong>{{ line.payment?.invoice?.emailClient }}</strong>
        </div>
        <div class="detail-item">
          <span class="detail-label">{{'invoice.idClient'|traduccion}}</span>
          <strong>{{ line.payment?.invoice?.typeIdClient }} {{ line.payment?.invoice?.idClient }}</strong>
        </div>
      </div>

      <div class="action-row">
        <button mat-stroked-button (click)="downloadFactura()"><mat-icon>download</mat-icon>{{'invoice.download'|traduccion}}</button>
      </div>
    </mat-card>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <button mat-stroked-button (click)="openSend()">
    <mat-icon>send</mat-icon>
    {{'payment.action.send'|traduccion}}
  </button>
  <button mat-stroked-button (click)="resendEmail()">
    <mat-icon>send</mat-icon>
    {{'payment.action.resend'|traduccion}}
  </button>
  <button mat-flat-button color="primary" (click)="goToViewer(line.orderUuid)">
    <mat-icon>summarize</mat-icon>
    {{'payment.action.viewer'|traduccion}}
  </button>
</mat-dialog-actions>
